// extracted by mini-css-extract-plugin
module.exports = {"survcont":"NewSurvey_survcont__2etqx","newsurvbtn":"NewSurvey_newsurvbtn__1pHvp","heading":"NewSurvey_heading__2xK2r","accordionContainer":"NewSurvey_accordionContainer__3TkO9"};